import React, { useState, useEffect, useRef } from 'react';

import { prepareInput, splitInputsByRenderBlock } from '../Input';
import { courseRegFreeInputs } from './courseRegFreeInputs';
import { Button } from '~c/ui/Button';
import { CheckSubscribe } from '../CheckSubscribe';
import { FormMessage } from '~c/FormMessage';
import { ButtonTabs } from '~c/ui/ButtonTabs';
import StudentsForm from '../StudentsForm';
import openErrorMsgForm from '~c/popups/ErrorSender';

import messages from '~h/messages';
import { createLeadRequest, registerStudents, sentUsersBrowserData } from '../utils';
import metrikaGoal from '../../../helpers/metrikaGoal';
import {registerAnalyticEvent} from '../analytics';

export const CourseRegFree = (props) => {
	const [inputs, setInputs] = useState(courseRegFreeInputs);
	const [formData, setFormData] = useState({});
	const [isSelfReg, setIsSelfReg] = useState(true);
	const [isPending, setIsPending] = useState(false);
	const [subscribe, setSubscribe] = useState(true);
	const [errorMessages, setErrorMessages] = useState([]);
	const [currentLead, setCurrentLead] = useState('');
	const [isPhoneCorrect, setPhoneCorrect] = useState(true);
	const [showAlert, setShowAlert] = useState(false);

	const studentsFormRef = useRef(null);

	const getCurrentLead = async () => {
		if (props.user){
			metrikaGoal('sendLead');
			const response = await createLeadRequest(props.user, props.eventCode, props.pageCode);
			return response.data?.NEW_REGISTRATION_ID;
		}
		return '';
	};

  const changeInput = (inputName, val) => {
    const newFormData = Object.assign({}, formData);
    newFormData[inputName] = val;
    setFormData(newFormData);
  };

  const isValidInput = (inputObject, inputValue) => {
    if (inputObject.validator) return inputObject.validator(inputValue);
    if (inputObject.required && inputValue) return true;
    return !inputObject.required;

  };

	const validateInput = name => {
    const currentInputIndex = inputs.findIndex(input => input.name === name);
    const currentInput = inputs[currentInputIndex];

    const isValid = isValidInput(currentInput, formData[currentInput.name]);

    if (!isValid !== currentInput.error) {
      const newInputs = inputs.slice(0);
      newInputs[currentInputIndex] = { ...currentInput, error: !isValid };
      setInputs(newInputs);
    }
  };

	const validateForm = () => {
    const newInputs = inputs.slice(0);

    let isValidationPassed = true;

		const errors = [];

    if(isSelfReg) {
			newInputs.forEach((input, index) => {
				const isValid = isValidInput(input, formData[input.name]);
	
				isValidationPassed = isValidationPassed && isValid;
				if (!isValid !== input.error) {
					newInputs[index] = { ...input, error: !isValid };
				}
			});
			setInputs(newInputs);
	
		} else {
			isValidationPassed = studentsFormRef.current?.validateForm();
		}

		if(!isValidationPassed) errors.push(messages.formError);

		setErrorMessages(errors);

    return isValidationPassed;
  };

	const onComponentMount = async () => {
		const leadId = await getCurrentLead();
		setCurrentLead(leadId);
	};

  const onSubmit = async () => {
    if (isPending) return;

		const { eventCode, pageCode } = props;
		const options = {
			subscribe,
			eventCodes: [eventCode],
			pageCode,
			isSelfReg,
			currentLead
		};
		const studentsData = studentsFormRef.current?.getData();

    if (!validateForm()) {
      // eslint-disable-next-line no-console
      console.error('forms invalid');
      return;
    }
		setErrorMessages([]);

		setIsPending(true);

		metrikaGoal('createFreeReg');
		if (subscribe) sentUsersBrowserData({data: formData, isNewsSubscribe: subscribe});
		try{
			const response = await registerStudents(isSelfReg ? [formData] : studentsData, options, null, props.eventTypes);
			setIsPending(false);

			if (response[0].status === 'success') {
				registerAnalyticEvent();
				props.nextStep();
			} else if (response[0].status === 'error') {
				setErrorMessages([response[0].errors[0].message]);
				throw new Error(response[0].errors[0].message);
			} else {
				setErrorMessages([messages.unknownError]);
				throw new Error(messages.unknownError);
			}
		}catch(e){
			const errorText = `${e.name} : ${e.message}`;
        const title = document.getElementsByTagName('h1')[0]?.innerHTML || '';
        const currentLocation = window.location.pathname;
        const error = {
          errors: errorText,
          page: `Регистрация на бесплатный курс. Страница: ${title}. URL: ${currentLocation}`
        };
			openErrorMsgForm(error);
		}
  };

	useEffect(() => {
    setFormData({
			name: props.user?.name || '',
			lastName: props.user?.lastName || '',
			patronymic: props.user?.patronymic || '',
			phone: props.user?.phone || '',
			email: props.user?.email || '',
			company: props?.user?.company || '',
			companyPosition: props?.user?.companyPosition || '',
    });
  }, [props.user]);

	useEffect(() => {
		onComponentMount();
		metrikaGoal('openRegPage');
	}, []);

	useEffect(() => {
		setErrorMessages([]);
		setInputs(courseRegFreeInputs);
	}, [isSelfReg]);

	const splittedInputs = splitInputsByRenderBlock(inputs);

	const removeSelection = () => {
		if (!isPhoneCorrect && showAlert) {
		  setPhoneCorrect(!isPhoneCorrect);
		  setShowAlert(false);
		}
	  };

	return (
		<div className="registration">
			<h4 className="heading heading--2 heading--reverse">
				Регистрация на мероприятие
			</h4>
			<ButtonTabs
				className="registration__tabs"
				options={[
					{
						label: 'Регистрируюсь сам',
						value: true,
						checked: isSelfReg,
					},
					{
						label: 'Регистрирую другого участника',
						value: false,
						checked: !isSelfReg,
					},
				]}
				onChange={setIsSelfReg}
			/>

			<div className={`registration__form${!isSelfReg ? ' hidden' : ''}`}>
				{splittedInputs.map((block) => (
					<div className="inp-wrap" key={block[0].name}>
						{block?.map(input =>
							prepareInput({
								...input,
								value: formData[input.name],
								onChangeCallback: changeInput,
								onBlurCallback: validateInput,
							}),
						)}
					</div>
				))}
			</div>
			<div className={`registration-block ${isSelfReg ? ' hidden' : ''}`}>
				<StudentsForm 
				showAlert={showAlert}
				removeSelection={removeSelection}
				ref={studentsFormRef} 
				isPhoneCorrect={isPhoneCorrect} 
				setPhoneCorrect={setPhoneCorrect}/>
			</div>
      { errorMessages.length >= 1 && (
        <React.Fragment>
          <FormMessage extraClass="error">
            { errorMessages.map((error) => <p className="form-message__p" key={error}>{error}</p>)}
          </FormMessage>
        </React.Fragment>
      )}
      { (props.checkSubscribe || props.user?.subscribe) ||
				<CheckSubscribe checked={subscribe} onChange={setSubscribe} />
			}
      <div className="registration__btns">
				<Button isPending={isPending} onClick={onSubmit}>Зарегистрироваться</Button>
			</div>
		</div>
	);
};